import React, { useMemo } from 'react'

import Heading from '@react/react-spectrum/Heading'
import Wait from '@react/react-spectrum/Wait'

import BarChart from 'components/BarChart/BarChart'
import { useProject } from 'hooks'
import { useProjectInsights } from 'services/project'

import './InsightsTab.scss'

function SettingsForm() {
  const { project } = useProject()
  const [{ data, loading }] = useProjectInsights(project.id)

  const visits = useMemo(() => data?.visits?.map((v) => ({ label: formatDate(v.date), value: v.visits })), [data])

  const users = useMemo(() => data?.users, [data])

  return (
    <div className='InsightsTab'>
      <section className='VisitsReport'>
        <Heading size='3'>Visits</Heading>
        {loading && <Wait />}
        {visits && <BarChart data={visits} />}
      </section>

      <section className='VisitsReport'>
        <Heading size='3'>Users</Heading>
        {loading && <Wait />}
        {users && (
          <div className='InsightsTab__users'>
            <table>
              <thead>
                <td>User ID</td>
                <td>Visits</td>
              </thead>
              <tbody>
                {users?.map((item) => (
                  <tr key={item.user}>
                    <td>{item.user}</td>
                    <td>{item.visits}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  )
}

function formatDate(string) {
  const date = new Date(string)
  return date.toLocaleDateString().replace(new RegExp(`.${date.getFullYear()}`), '')
}

export default SettingsForm
